// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalPortal_modal__-xwjQ {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 66px 40px 40px;
}
.ModalPortal_modal__-xwjQ .modal__title {
  font-size: 20px;
  line-height: 24px;
  font-weight: 600;
}
.ModalPortal_modal--sm__JKcMf .ModalPortal_inner__s1mDt {
  max-width: 560px;
}
.ModalPortal_modal--lg__TNxXl .ModalPortal_inner__s1mDt {
  max-width: 960px;
}
.ModalPortal_modal--is-active__mKKEg {
  opacity: 1;
  visibility: visible;
}

.ModalPortal_overlay__SNaeX {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
}

.ModalPortal_inner__s1mDt {
  position: relative;
  border-radius: 16px;
  background-color: var(--white);
  max-width: 760px;
  width: 100%;
  padding: var(--grid-space);
}

.ModalPortal_header__AgKin {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #E0E7EB;
  min-height: 60px;
  padding: 16px;
  padding-right: 52px;
  position: relative;
}
.ModalPortal_header__AgKin .ModalPortal_btn__mquFJ {
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
}

.ModalPortal_btn__mquFJ {
  position: absolute;
  top: 40px;
  right: 40px;
  border: none;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 100%;
  background-color: var(--gray-20);
  transition: var(--transition);
  transition-property: opacity, background-color;
}
@media (hover: hover) {
  .ModalPortal_btn__mquFJ:hover {
    opacity: 0.8;
  }
}

.ModalPortal_body__pdVlw {
  padding: 16px;
}
.ModalPortal_body--no-padding__8CPgD {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Assets/ModalPortal/ModalPortal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EAGA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAII;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAFN;AAOI;EACE,gBAAA;AALN;AAUI;EACE,gBAAA;AARN;AAYE;EACE,UAAA;EACA,mBAAA;AAVJ;;AAcA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;AAXF;;AAcA;EACE,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,0BAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAXF;AAaE;EACE,QAAA;EACA,2BAAA;EACA,WAAA;AAXJ;;AAeA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,6BAAA;EACA,8CAAA;AAZF;AAcE;EACE;IACE,YAAA;EAZJ;AACF;;AAgBA;EACE,aAAA;AAbF;AAeE;EACE,UAAA;AAbJ","sourcesContent":[".modal {\r\n  position: fixed;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.3);\r\n  z-index: 100;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  //transition: var(--transition);\r\n  //transition-property: opacity, visibility;\r\n  overflow: auto;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 66px 40px 40px;\r\n\r\n  :global {\r\n    .modal__title {\r\n      font-size: 20px;\r\n      line-height: 24px;\r\n      font-weight: 600;\r\n    }\r\n  }\r\n\r\n  &--sm {\r\n    .inner {\r\n      max-width: 560px;\r\n    }\r\n  }\r\n\r\n  &--lg {\r\n    .inner {\r\n      max-width: 960px;\r\n    }\r\n  }\r\n\r\n  &--is-active {\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n.overlay {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  z-index: -1;\r\n}\r\n\r\n.inner {\r\n  position: relative;\r\n  border-radius: 16px;\r\n  background-color: var(--white);\r\n  max-width: 760px;\r\n  width: 100%;\r\n  padding: var(--grid-space);\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  border-bottom: 1px solid #E0E7EB;\r\n  min-height: 60px;\r\n  padding: 16px;\r\n  padding-right: 52px;\r\n  position: relative;\r\n\r\n  .btn {\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    right: 16px;\r\n  }\r\n}\r\n\r\n.btn {\r\n  position: absolute;\r\n  top: 40px;\r\n  right: 40px;\r\n  border: none;\r\n  padding: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 100%;\r\n  background-color: var(--gray-20);\r\n  transition: var(--transition);\r\n  transition-property: opacity, background-color;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n}\r\n\r\n.body {\r\n  padding: 16px;\r\n\r\n  &--no-padding {\r\n    padding: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ModalPortal_modal__-xwjQ`,
	"modal--sm": `ModalPortal_modal--sm__JKcMf`,
	"inner": `ModalPortal_inner__s1mDt`,
	"modal--lg": `ModalPortal_modal--lg__TNxXl`,
	"modal--is-active": `ModalPortal_modal--is-active__mKKEg`,
	"overlay": `ModalPortal_overlay__SNaeX`,
	"header": `ModalPortal_header__AgKin`,
	"btn": `ModalPortal_btn__mquFJ`,
	"body": `ModalPortal_body__pdVlw`,
	"body--no-padding": `ModalPortal_body--no-padding__8CPgD`
};
export default ___CSS_LOADER_EXPORT___;
